'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	cleanUpContentForExport = require('./clean-up-content-for-export');
//TODO: maybe investigate merging with copy file controller
module.exports = function LinkedSubmapController(config, fileModel, contentRetriver, mapEditorModel, navigatorShim) {
	const dispatcher = observable(this),
		tryWatermarking = async (metadata) => {
			if (!metadata || !metadata.id || !metadata.id.split || !fileModel.requestWatermarkForFileKey) {
				return;
			}
			try {
				const components  = metadata.id.split('/'),
					fileId = components[components.length - 1];
				await fileModel.requestWatermarkForFileKey(`${fileId}.pointer`, true);
			} catch (e) {
				console.error(e); //eslint-disable-line
			}
		},
		saveSubmapForNodeId = async function (selectedId) {
			const content = await contentRetriver({export: {startFrom: selectedId}}),
				cleanContentForExport = cleanUpContentForExport(content),
				//todo: insert link to main map
				stringifiedContentForExport = JSON.stringify(cleanContentForExport),
				metadata = await fileModel.createFile(mapEditorModel.getSuggestedSubmapName(selectedId), false, stringifiedContentForExport);
			await tryWatermarking(metadata);
			return metadata;
		},
		extractSubmap = async function () {
			try {
				dispatcher.dispatchEvent('stage', 'progress');
				const activatedNodeLayouts = mapEditorModel.getActivatedNodeIdsWithLayouts(),
					deepestFirst = activatedNodeLayouts
						.sort((lhs, rhs) => rhs.layout.level - lhs.layout.level);
				for (const n of deepestFirst) {
					const selectedId = n.nodeId,
						metadata = await saveSubmapForNodeId(selectedId);
					mapEditorModel.replaceSubmapWithLink(selectedId, navigatorShim.getOrigin() + config.editorUrl + '/' +  metadata.id);
				}
				dispatcher.dispatchEvent('stage', 'done');
			} catch(error) {
				if (error === 'not-authenticated') {
					dispatcher.dispatchEvent('stage', 'error-not-authenticated');
				} else {
					dispatcher.dispatchEvent('stage', 'error');
				}
			}

		};
	Object.freeze(Object.assign(this, {extractSubmap}));
};
